var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c-170.667 0-307.2 136.533-307.2 307.2s136.533 307.2 307.2 307.2 307.2-136.533 307.2-307.2-136.533-307.2-307.2-307.2v0zM512 546.133c-129.707 0-238.933-109.227-238.933-238.933s109.227-238.933 238.933-238.933 238.933 109.227 238.933 238.933-109.227 238.933-238.933 238.933v0z M546.133 614.4h-68.267v409.6h68.267v-409.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.31ee313263693982f9040a78c2c6b5a6.svg";
export { ForwardRef as ReactComponent };